import { useCallback, useMemo, useState } from 'react';

import { Tooltip } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { ConsentList } from './components/ConsentList';
import { RevokeConsentModal } from './components/RevokeConsentModal';
import { Consent } from './types';
import { useGetTellMoneyUserConsent } from './useGetTellMoneyUserConsent';

export const ConsentManagement = () => {
    const consents = useGetTellMoneyUserConsent();
    const [selectedConsent, setSelectedConsent] = useState<Consent | null>(
        null
    );

    const { activeConsents, inactiveConsents } = useMemo(() => {
        const active = consents.filter((consent) => consent.active);
        const inactive = consents.filter((consent) => !consent.active);
        return {
            activeConsents: active,
            inactiveConsents: inactive
        };
    }, [consents]);

    const handleDisconnectClick = useCallback(
        (consent_id: string) => {
            const consent =
                consents.find((c) => c.consent_id === consent_id) || null;
            setSelectedConsent(consent);
        },
        [consents]
    );

    const handleDisconnectClose = useCallback(() => {
        setSelectedConsent(null);
    }, []);

    return (
        <>
            <h3 className="text-primary-30 mb-l text-m">
                <FormattedMessage
                    id="_.credit_card.preferences.consent_management.connected_apps"
                    defaultMessage="Connected apps"
                />
            </h3>
            <ConsentList
                handleDisconnectClick={handleDisconnectClick}
                consents={activeConsents}
            />
            <h3 className="text-primary-30 mb-l flex items-center gap-s text-m">
                <FormattedMessage
                    id="_.credit_card.preferences.consent_management.disconnected_apps"
                    defaultMessage="Disconnected apps"
                />
                <Tooltip
                    content={'These apps used to be connected to your account'}
                />
            </h3>
            <ConsentList
                handleDisconnectClick={handleDisconnectClick}
                consents={inactiveConsents}
            />
            <RevokeConsentModal
                onClose={handleDisconnectClose}
                consent={selectedConsent}
            />
        </>
    );
};
